import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

let conf = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSENGER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID
};

const config = conf;
let app;
if (!firebase.apps.length) {
  app = firebase.initializeApp(config);
}

const messaging = getMessaging(app);
const auth = firebase.auth();

const requestForToken = async () => {
  try {
    const currentToken = await getToken(messaging, {
      vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY
    });
    if (currentToken) {
      console.log('current token for client: ', currentToken);
      return currentToken;
    } else {
      // Show permission request UI
      console.log(
        'No registration token available. Request permission to generate one.'
      );
      return null;
    }
  } catch (err) {
    console.log('An error occurred while retrieving token. ', err);
    return null;
  }
};

const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });

/**
 *  Subscribe to messages from Firebase Cloud Messaging
 *
 * @param {*} handler - A callback function to handle incoming messages
 * @returns {function} A function to unsubscribe from messages
 */
const subscribeToMessages = (handler) => onMessage(messaging, handler);

export { auth, requestForToken, onMessageListener, subscribeToMessages };
